import { render } from "./Catalogos.vue?vue&type=template&id=a0ef8e4e"
import script from "./Catalogos.vue?vue&type=script&lang=js"
export * from "./Catalogos.vue?vue&type=script&lang=js"
script.render = render

export default script